import styled, { css } from 'styled-components';
import { Wrapper as SelectedOptionWrapper } from '@genericBookings/components/SelectedOption/styles';
export const Wrapper = styled.div `
  position: relative;
  display: block;
  width: 100%;
  max-width: 82rem;

  ${({ theme: { formGroup } }) => formGroup}

  ${({ isWide }) => isWide && css `
    @media screen and (min-width: 992px) {
      max-width: 100% !important;
    }
  `}

  ${({ half }) => half && css `
    ${({ theme: { halfFormGroup } }) => halfFormGroup}
  `}
  
  ${SelectedOptionWrapper} {
    z-index: 12;
  }
`;
export default {
    Wrapper,
};
